import {
    Avatar,
    Box,
    Button,
    Container,
    Dialog,
    DialogContent,
    Divider,
    Grid,
    Hidden,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    TextField,
    Typography,
    useTheme,
} from "@material-ui/core";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import {
    CheckCircleOutlineOutlined,
    HighlightOffOutlined,
} from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { WithContext as ReactTags } from "react-tag-input";
import Swal from "sweetalert2";
import plusIcon from "../../assets/images/plus-circle.svg";
import pic1 from "../../assets/images/setUpMeetingDesc.png";
import pic3 from "../../assets/images/setUpMeetingInvite.png";
import pic2 from "../../assets/images/setUpMeetingProduct.png";
import pic from "../../assets/images/setUpMeetingTitle.png";
import { useStyles } from "../../components/common/MainStyles.jsx";
import { IsNullOrEmpty, slugify } from "../../helpers/utility";
import {
    deleteExistingProduct,
    getProductRequest,
    selectExistingProduct,
} from "../../store/shopping/shopping.actions";
import {
    getProductList,
    getProducts,
} from "../../store/shopping/shopping.selector";
import { createLiveStreamRequest } from "../../store/social/social.actions";
import { getDeliveryAddresses } from "../../store/user/deliveryaddress/deliveryaddress.selector";
import { searchUserRequest } from "../../store/user/user.actions";
import {
    getImage,
    getSearchedUsers,
    getUserProfile,
} from "../../store/user/user.selector";
import AddAddress from "../AccountPreferences/addAddress";
import ProductCard from "./product_card";

export default function SetupPublicHall(props) {
    const dispatch = useDispatch();
    const history = useNavigate();
    const classes = useStyles();
    const theme = useTheme();
    const [guests, setGuests] = useState([]);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [hashTags, setHashTags] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [newProduct, setNewProduct] = useState(false);
    const [editProduct, setEditProduct] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState({});
    const [searchText, setSearchText] = useState("");
    const [addAddress, setAddAddress] = useState(false);
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();

    function getSteps() {
        return ["Title", "Description", "Product", "Invite"];
    }

    function getStepContent(stepIndex) {
        switch (stepIndex) {
            case 0:
                return (
                    <Container maxWidth="xl" className="my-4">
                        <Box className="mb-4">
                            <Typography
                                variant="h5"
                                component="p"
                                className={classes.title}
                            >
                                Give a name to your live
                            </Typography>
                            <Typography
                                variant="p"
                                component="p"
                                className={classes.subTitle}
                            >
                                Make it easier for people to find
                            </Typography>
                        </Box>
                        <Box
                            height="100%"
                            minHeight={"49.5vh"}
                            display={"flex"}
                            justifyContent="space-between"
                            flexDirection={"column"}
                        >
                            <TextField
                                label="Title"
                                fullWidth
                                variant="outlined"
                                placeholder="Title"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                className="my-2 bg-white"
                            />
                            <div className="my-4">
                                <Button
                                    variant="contained"
                                    className={classes.bgwhite}
                                    onClick={() => props.onClose()}
                                >
                                    Previous
                                </Button>
                                <Button
                                    variant="contained"
                                    className="ml-2"
                                    color={
                                        !IsNullOrEmpty(title)
                                            ? "secondary"
                                            : "inherit"
                                    }
                                    disabled={IsNullOrEmpty(title)}
                                    onClick={() => handleNext()}
                                >
                                    Next
                                </Button>
                            </div>
                        </Box>
                    </Container>
                );
            case 1:
                return (
                    <Container maxWidth="xl" className="my-4">
                        <Box className="mb-4">
                            <Typography
                                variant="h5"
                                component="p"
                                className={classes.title}
                            >
                                Describe your live
                            </Typography>
                            <Typography
                                variant="p"
                                component="p"
                                className={classes.subTitle}
                            >
                                Tell the audience more about your live
                            </Typography>
                        </Box>
                        <Box
                            height="100%"
                            minHeight={"49.5vh"}
                            display={"flex"}
                            justifyContent="space-between"
                            flexDirection={"column"}
                        >
                            <div>
                                <TextField
                                    label="Your description"
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Your description"
                                    minRows={4}
                                    multiline
                                    classes={{
                                        inputMultiline: "bg-white",
                                    }}
                                    inputProps={{
                                        maxLength: 80,
                                    }}
                                    value={description}
                                    onChange={(e) =>
                                        setDescription(e.target.value)
                                    }
                                    className="my-2 "
                                    helperText={
                                        description.length > 0 ? (
                                            <span className="float-right text-danger">{`${
                                                80 - description.length
                                            } characters remaining`}</span>
                                        ) : (
                                            ""
                                        )
                                    }
                                />

                                {IsNullOrEmpty(description) ? (
                                    <>
                                        <p className="text-disabled mb-4 text-grey text-small">
                                            Max 80 characters
                                        </p>
                                    </>
                                ) : (
                                    <span />
                                )}
                                <ReactTags
                                    tags={hashTags}
                                    handleInputBlur={(e) =>
                                        handleAddition({
                                            id: e,
                                            text: e,
                                        })
                                    }
                                    inputFieldPosition="inline"
                                    placeholder="Add new tags"
                                    autofocus={false}
                                    handleDelete={handleDelete}
                                    handleAddition={handleAddition}
                                    maxLength={20}
                                    allowUnique
                                    handleDrag={handleDrag}
                                    delimiters={delimiters}
                                    classNames={{
                                        selected: classes.selectedTags,
                                        tagInput: classes.tagInput,
                                    }}
                                />
                                <p className="text-disabled mt-1 text-small text-grey">
                                    Max 5 unique hashtags
                                </p>
                            </div>
                            <div className="my-4">
                                <Button
                                    variant="contained"
                                    onClick={() => handleBack()}
                                    className={classes.bgwhite}
                                >
                                    Previous
                                </Button>
                                <Button
                                    variant="contained"
                                    className="ml-2"
                                    color={
                                        !IsNullOrEmpty(description)
                                            ? "secondary"
                                            : "inherit"
                                    }
                                    disabled={IsNullOrEmpty(description)}
                                    onClick={() => handleNext()}
                                >
                                    Next
                                </Button>
                            </div>
                        </Box>
                    </Container>
                );
            case 2:
                return (
                    <Container maxWidth="xl" className="my-2">
                        <Box className="my-2">
                            <Typography
                                variant="h5"
                                component="p"
                                className={classes.title}
                            >
                                Sell something in your live
                            </Typography>
                            <Typography
                                variant="p"
                                component="p"
                                className={classes.subTitle}
                            >
                                Add product or skip by pressing next
                            </Typography>
                        </Box>
                        <Box
                            height="100%"
                            minHeight={"49.5vh"}
                            display={"flex"}
                            justifyContent="space-between"
                            flexDirection={"column"}
                        >
                            {(newProduct || editProduct) && !addAddress ? (
                                <></>
                            ) : (
                                <div
                                    className="sidenav"
                                    style={{ width: open ? "35%" : 0 }}
                                >
                                    <div className="p-4">
                                        <Typography
                                            variant="p"
                                            component="p"
                                            className={classes.dashboardTitle}
                                        >
                                            Saved Products
                                        </Typography>
                                    </div>
                                    <Divider />
                                    <List
                                        disablePadding
                                        className={classes.sideList}
                                    >
                                        {productList.map((x) => {
                                            let isExists =
                                                products.filter(
                                                    (y) => x._id === y._id
                                                ).length > 0;
                                            return (
                                                <ListItem
                                                    disableGutters
                                                    onClick={() => {
                                                        if (!isExists) {
                                                            let data = {
                                                                status: x.status,
                                                                shippingFee:
                                                                    x.shippingFee,
                                                                _id: x._id,
                                                                name: x.name,
                                                                descriptions:
                                                                    x.descriptions,
                                                                images: x.images
                                                                    ? x.images
                                                                    : getImage(
                                                                          x.attachments
                                                                      ),
                                                                attachments:
                                                                    x
                                                                        .attachments
                                                                        ._id,
                                                                price: x.price,
                                                                user: x.user,
                                                                code: x.code,
                                                                currency:
                                                                    x.currency,
                                                                warehouse:
                                                                    x.warehouse
                                                                        ._id,
                                                                dateCreated:
                                                                    x.dateCreated,
                                                                dateUpdated:
                                                                    x.dateUpdated,
                                                                quantity:
                                                                    x.warehouse
                                                                        .quantity,
                                                                purcharse:
                                                                    x.warehouse
                                                                        .purcharse,
                                                                remaining:
                                                                    x.warehouse
                                                                        .remaining,
                                                            };
                                                            dispatch(
                                                                selectExistingProduct(
                                                                    data
                                                                )
                                                            );
                                                        }
                                                    }}
                                                >
                                                    <ListItemAvatar>
                                                        <Avatar
                                                            variant="square"
                                                            sizes="100"
                                                            src={
                                                                x.images
                                                                    ? x.images
                                                                    : getImage(
                                                                          x.attachments,
                                                                          "product"
                                                                      )
                                                            }
                                                            className="img-responsive"
                                                            alt="icon"
                                                        />
                                                    </ListItemAvatar>
                                                    <ListItemText
                                                        primary={x.name}
                                                        secondary={x.code}
                                                    />
                                                    <ListItemSecondaryAction>
                                                        {isExists ? (
                                                            <CheckCircleOutlineOutlined color="primary" />
                                                        ) : (
                                                            <CheckCircleOutlineOutlined
                                                                color="disabled"
                                                                onClick={() => {
                                                                    if (
                                                                        !isExists
                                                                    ) {
                                                                        let data =
                                                                            {
                                                                                status: x.status,
                                                                                shippingFee:
                                                                                    x.shippingFee,
                                                                                _id: x._id,
                                                                                name: x.name,
                                                                                descriptions:
                                                                                    x.descriptions,
                                                                                images: x.images
                                                                                    ? x.images
                                                                                    : getImage(
                                                                                          x.attachments
                                                                                      ),
                                                                                attachments:
                                                                                    x
                                                                                        .attachments
                                                                                        ._id,
                                                                                price: x.price,
                                                                                user: x.user,
                                                                                code: x.code,
                                                                                currency:
                                                                                    x.currency,
                                                                                warehouse:
                                                                                    x
                                                                                        .warehouse
                                                                                        ._id,
                                                                                dateCreated:
                                                                                    x.dateCreated,
                                                                                dateUpdated:
                                                                                    x.dateUpdated,
                                                                                quantity:
                                                                                    x
                                                                                        .warehouse
                                                                                        .quantity,
                                                                                purcharse:
                                                                                    x
                                                                                        .warehouse
                                                                                        .purcharse,
                                                                                remaining:
                                                                                    x
                                                                                        .warehouse
                                                                                        .remaining,
                                                                            };
                                                                        dispatch(
                                                                            selectExistingProduct(
                                                                                data
                                                                            )
                                                                        );
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                    </ListItemSecondaryAction>
                                                </ListItem>
                                            );
                                        })}
                                    </List>
                                    <Button
                                        color="secondary"
                                        variant="contained"
                                        className="mx-2"
                                        fullWidth
                                        onClick={() => setOpen(false)}
                                    >
                                        Done
                                    </Button>
                                </div>
                            )}
                            <Grid container spacing={3} className="my-2">
                                <Dialog
                                    PaperProps={{
                                        style: {
                                            background: "none",
                                            boxShadow: "none",
                                        },
                                    }}
                                    maxWidth="sm"
                                    fullWidth
                                    open={
                                        (newProduct || editProduct) &&
                                        !addAddress
                                    }
                                >
                                    <DialogContent>
                                        {newProduct ? (
                                            <ProductCard
                                                product={{}}
                                                isAdd={true}
                                                onClose={() =>
                                                    setNewProduct(false)
                                                }
                                            />
                                        ) : editProduct ? (
                                            <ProductCard
                                                product={selectedProduct}
                                                isAdd={false}
                                                onClose={() =>
                                                    setEditProduct(false)
                                                }
                                            />
                                        ) : (
                                            <></>
                                        )}
                                    </DialogContent>
                                </Dialog>
                                {user.role === "Basic" ? (
                                    <>
                                        {[0, 1, 2, 4, 5, 6, 7, 8, 9].map(
                                            (pr, index) => {
                                                return (
                                                    <ProductSquare
                                                        pos={index}
                                                    />
                                                );
                                            }
                                        )}
                                    </>
                                ) : (
                                    <>
                                        {[
                                            0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
                                            11, 12, 13, 14, 15, 16, 17, 18, 19,
                                        ].map((pr, index) => {
                                            return (
                                                <ProductSquare pos={index} />
                                            );
                                        })}
                                    </>
                                )}
                            </Grid>
                            {productList.length > 0 && (
                                <Button
                                    color="primary"
                                    className="my-1"
                                    variant="text"
                                    onClick={() => setOpen(true)}
                                >
                                    Choose saved product
                                </Button>
                            )}

                            <div className="mt-1">
                                <Button
                                    variant="contained"
                                    onClick={() => handleBack()}
                                    className={classes.bgwhite}
                                >
                                    Previous
                                </Button>
                                <Button
                                    className="ml-2"
                                    variant="contained"
                                    color={"secondary"}
                                    onClick={() => {
                                        handleNext();
                                    }}
                                >
                                    Next
                                </Button>
                            </div>
                        </Box>
                    </Container>
                );
            case 3:
                return (
                    <Container maxWidth="xl" className="my-2">
                        <Box className="my-2">
                            <Typography
                                variant="h5"
                                component="p"
                                className={classes.title}
                            >
                                Invite friends as your co-host
                            </Typography>
                            <Typography
                                variant="p"
                                component="p"
                                className={classes.subTitle}
                            >
                                You must follow them first to invite them
                            </Typography>
                        </Box>
                        <Box>
                            <div className="relative mb-3.5">
                                <input
                                    value={searchText}
                                    onChange={(e) =>
                                        setSearchText(e.target.value)
                                    }
                                    type="search"
                                    className="py-2.5 pl-12 w-full text-black-color placeholder:text-black-60 border border-black-10 rounded-[40px] text-md sm:text-md outline-none"
                                    placeholder="Search"
                                />

                                <span className="text-xl absolute top-2/4 -translate-y-2/4 left-5 text-black-60">
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2ZM0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 7.29583 11.5892 8.49572 10.8907 9.47653L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L9.47653 10.8907C8.49572 11.5892 7.29583 12 6 12C2.68629 12 0 9.31371 0 6Z"
                                            fill="black"
                                            fillOpacity="0.5"
                                        />
                                    </svg>
                                </span>
                            </div>
                            <Grid
                                container
                                spacing={2}
                                className={classes.guestList}
                            >
                                {guestUsers.map((item) => {
                                    let isActive =
                                        guests.indexOf(item._id) > -1;
                                    return (
                                        <Grid
                                            item
                                            key={item._id}
                                            sm={4}
                                            xs={4}
                                            md={2}
                                            lg={2}
                                        >
                                            <Box
                                                textAlign="center"
                                                display={"flex"}
                                                justifyContent="center"
                                                alignItems={"center"}
                                                flexDirection={"column"}
                                            >
                                                <Avatar
                                                    style={{
                                                        height: 64,
                                                        width: 64,
                                                        border: isActive
                                                            ? "3px solid " +
                                                              theme.palette
                                                                  .primary.main
                                                            : "1px solid " +
                                                              theme.palette
                                                                  .grey[800],
                                                    }}
                                                    src={getImage(
                                                        item.attachments
                                                    )}
                                                    title={item.fullName}
                                                    alt={item.fullName}
                                                    onClick={() => {
                                                        let index =
                                                            guests.findIndex(
                                                                (x) =>
                                                                    x ===
                                                                    item._id
                                                            );
                                                        if (index > -1) {
                                                            let newGuests =
                                                                guests.filter(
                                                                    (y) =>
                                                                        y !==
                                                                        item._id
                                                                );
                                                            setGuests(
                                                                newGuests
                                                            );
                                                        } else {
                                                            setGuests([
                                                                ...guests,
                                                                item._id,
                                                            ]);
                                                        }
                                                    }}
                                                />
                                                <span
                                                    className="overflow-text text-small"
                                                    title={item.fullName}
                                                    style={{
                                                        color: isActive
                                                            ? theme.palette
                                                                  .primary.main
                                                            : theme.palette
                                                                  .grey[800],
                                                    }}
                                                >
                                                    {item.fullName}
                                                </span>
                                            </Box>
                                        </Grid>
                                    );
                                })}
                            </Grid>

                            <div className="my-4">
                                <Button
                                    variant="contained"
                                    className={classes.bgwhite}
                                    onClick={() => handleBack()}
                                >
                                    Previous
                                </Button>
                                <Button
                                    className="ml-2"
                                    variant="contained"
                                    color={"secondary"}
                                    onClick={() => {
                                        handleCreateLiveStream();
                                    }}
                                >
                                    Start live
                                </Button>
                            </div>
                        </Box>
                    </Container>
                );
            default:
                return "Unknown stepIndex";
        }
    }

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const KeyCodes = {
        comma: 188,
        enter: 13,
        space: 32,
    };
    const delimiters = [KeyCodes.comma, KeyCodes.enter, KeyCodes.space];

    let guestUsers = [];
    const {
        products,
        users,
        user,
        productList,
        deliveryAddress,
        deliveryLoading,
    } = useSelector((state) => {
        return {
            users: getSearchedUsers(state),
            products: getProductList(state),
            user: getUserProfile(state),
            productList: getProducts(state),
            deliveryAddress: getDeliveryAddresses(state),
            deliveryLoading: state.DeliveryAddressReducer.isLoading,
        };
    });

    useEffect(() => {
        if ((newProduct || open) && !addAddress) {
            if (!deliveryLoading && deliveryAddress.length === 0) {
                Swal.fire({
                    allowOutsideClick: false,
                    title: "Add your address",
                    text: "You haven’t added any shipping address yet please click below to add.",
                    icon: "warning",
                    iconHtml: `<img src="${require("../../assets/images/map.png")}" />`,
                    confirmButtonText: "Add new address",
                    showCancelButton: true,
                    customClass: {
                        cancelButton: "order-1 right-gap",
                        confirmButton: "order-2",
                        denyButton: "order-3",
                        icon: "custom-swal-icon",
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        setAddAddress(true);
                    }
                    if (result.isDismissed) {
                        setNewProduct(false);
                        setOpen(false);
                        setEditProduct(false);
                    }
                });
            }
        }
    }, [newProduct, open, deliveryAddress, deliveryLoading]);

    useEffect(() => {
        setNewProduct(false);
        setEditProduct(false);
    }, [products]);

    useEffect(() => {
        dispatch(getProductRequest());
        if (users.length === 0) {
            dispatch(searchUserRequest());
        }
    }, []);

    const ProductSquare = ({ pos }) => {
        return (
            <Grid item xs={4} sm={4} lg={2} md={2}>
                <Box
                    onClick={() => {
                        if (products && products.length > pos) {
                            setEditProduct(true);
                            setSelectedProduct(products[pos]);
                        } else {
                            setNewProduct(true);
                        }
                    }}
                    textAlign="center"
                    margin={"0 auto"}
                    className={classes.productBox}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    {products && products.length > pos ? (
                        <div className="img-wrap">
                            <HighlightOffOutlined
                                className="close"
                                onClick={() =>
                                    dispatch(deleteExistingProduct(pos))
                                }
                            />
                            <img
                                className="img-responsive"
                                src={products[pos].images}
                            />
                        </div>
                    ) : (
                        <img src={plusIcon} />
                    )}
                </Box>
            </Grid>
        );
    };

    const handleCreateLiveStream = () => {
        let data = {
            type: "main",
            category: props.category._id,
            title: title,
            contents: description,
            products: products.map((x) => {
                return {
                    id: x._id,
                    name: x.name,
                };
            }),
            guests: guestUsers.filter((x) => guests.indexOf(x._id) > -1),
            hashtags: hashTags.map((x) => slugify(x.id)),
        };
        if (products.length > 0) {
            data.currentProduct = products[0]._id;
        }

        dispatch(
            createLiveStreamRequest({
                data: data,
                history: history,
            })
        );
    };

    guestUsers = users.filter((x) => x.isFollow);

    if (!IsNullOrEmpty(searchText)) {
        guestUsers = guestUsers.filter((x) => {
            return (
                x.fullName.toLowerCase().indexOf(searchText.toLowerCase()) > -1
            );
        });
    }

    function handleDelete(i) {
        const tags = hashTags.filter((tag, index) => index !== i);
        setHashTags(tags);
    }

    function handleAddition(tag) {
        if (!IsNullOrEmpty(tag.id) && hashTags.length < 5) {
            setHashTags([...hashTags, tag]);
        }
    }

    function handleDrag(tag, currPos, newPos) {
        const tags = hashTags;
        const newTags = tags.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        // re-render
        setHashTags(newTags);
    }

    return (
        <main className={classes.main}>
            {addAddress && <AddAddress onClose={() => setAddAddress(false)} />}
            <Grid container className="h-[100%]">
                <Grid item xs={12} sm={12} lg={8} md={8}>
                    <Grid container className="pb-4">
                        <Grid item xs={12} sm={12} className="mb-2">
                            <Stepper
                                style={{ background: "transparent" }}
                                activeStep={activeStep}
                                alternativeLabel
                            >
                                {steps.map((label, index) => (
                                    <Step key={label}>
                                        <StepLabel
                                            color={
                                                index === activeStep
                                                    ? theme.palette.secondary
                                                          .main
                                                    : theme.palette.primary
                                                          .contrastText
                                            }
                                        >
                                            {label}
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </Grid>
                        <Grid item sm={12} xs={12}>
                            <Grid container alignItems="center">
                                <Grid item xs={12} sm={12}>
                                    {getStepContent(activeStep)}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12} lg={4} md={4}>
                    <Hidden implementation="js" only={["xs", "sm"]}>
                        <Box className="side-image-box">
                            <img
                                src={
                                    activeStep === 1
                                        ? pic1
                                        : activeStep === 2
                                        ? pic2
                                        : activeStep === 3
                                        ? pic3
                                        : pic
                                }
                                alt="pic"
                                className="img-responsive  rounded-xl"
                            />
                        </Box>
                    </Hidden>
                </Grid>
            </Grid>
        </main>
    );
}
